export var LienDefaultProps = {
    as: 'a',
    positionIcone: 'right',
    taille: 'md'
};
